import api from './api';

export interface DataAnalysisTopic {
  _id: string;
  name: string;
  category: 'Governance' | 'Privacy' | 'Security' | 'Quality' | 'Technical' | 'Operational' | 'Compliance' | 'Other';
  description?: string;
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateDataAnalysisTopic {
  name: string;
  category: 'Governance' | 'Privacy' | 'Security' | 'Quality' | 'Technical' | 'Operational' | 'Compliance' | 'Other';
  description?: string;
  order?: number;
  isActive?: boolean;
}

export interface UpdateDataAnalysisTopic extends Partial<CreateDataAnalysisTopic> {}

const base = '/data-analysis-topics';

const dataAnalysisTopicsService = {
  async list(q?: string): Promise<DataAnalysisTopic[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as DataAnalysisTopic[];
  },
  async create(payload: CreateDataAnalysisTopic): Promise<DataAnalysisTopic> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as DataAnalysisTopic;
  },
  async update(id: string, payload: UpdateDataAnalysisTopic): Promise<DataAnalysisTopic> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as DataAnalysisTopic;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default dataAnalysisTopicsService;
